import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';
import {
  PageHeaderUniDriver,
  ButtonUniDriver,
  PopoverMenuUniDriver,
} from '@wix/design-system/dist/testkit/unidriver';

export default (base: UniDriver, body: UniDriver) => {
  const moreActionsPopoverDriver = (dataHook: string) =>
    PopoverMenuUniDriver(base.$(`[data-hook="${dataHook}"]`), body);

  return {
    /** Returns primary action button driver */
    getPrimaryAction: (dataHook: string) =>
      ButtonUniDriver(base.$(`[data-hook="${dataHook}"]`), body),

    getMoreActions: (dataHook: string) => ({
      exists: () => moreActionsPopoverDriver(dataHook).exists(),

      /** Opens the more actions popover */
      open: () =>
        moreActionsPopoverDriver(dataHook)
          .getTriggerElement('more-actions-popover-button')
          .click(),
      /** Indicates whether the more actions popover is open */
      isOpen: () => moreActionsPopoverDriver(dataHook).isMenuOpen(),

      /** Clicks at child by data-hook */
      clickAtChildByDataHook: (childDataHook: string) =>
        moreActionsPopoverDriver(dataHook).clickAtChildByDataHook(
          childDataHook,
        ),

      /** Clicks at child by index */
      clickAtChildByIndex: (index: number) =>
        moreActionsPopoverDriver(dataHook).clickAtChild(index),

      /** Gets content at index */
      childContentAt: (index: number) =>
        moreActionsPopoverDriver(dataHook).itemContentAt(index),

      /** Gets children count */
      childrenCount: () => moreActionsPopoverDriver(dataHook).childrenCount(),
    }),

    getPageHeader: () =>
      PageHeaderUniDriver(base.$(`[data-hook="collection-page-header"]`), body),

    ...baseUniDriverFactory(base),
  };
};
